export default __webpack_public_path__ + "static/media/404.16bef08a.png";